import { UserConfiguration } from "ips/ac/model/odata/generated/IpsCoreModel";
import { ConfigurationDto } from "ips/ac/model/api/WinDoFlow.api.types";

export default class ConfigurationMapper {
  public static dtoListToUserConfigurationList(dtoList: ConfigurationDto[]): UserConfiguration[] {
    if (dtoList === undefined || dtoList.length === 0) {
      return [];
    }

    const clientConfigurations: UserConfiguration[] = [];
    dtoList.forEach((dto) => {
      clientConfigurations.push(ConfigurationMapper.dtoToUserConfiguration(dto));
    });
    return clientConfigurations;
  }

  public static dtoToUserConfiguration(dto: ConfigurationDto): UserConfiguration {
    if (dto === undefined || dto === null) {
      return undefined;
    }

    return {
      ApplicationDescription: "",
      ApplicationId: "",
      ConfigurationDescription: "",
      ConfigurationId: dto.systemId,
      Counter: 0,
      CreatedOn: "",
      IsActive: 0,
      IsDeleted: 0,
      Sid: dto.sid,
      UpdatedOn: "",
      UserGuid: "",
      Value: dto.value,

    };
  }
}